export const SIGNATURE_TYPE_WORK_CERTIFIED_BY = 'certified_by';
export const SIGNATURE_TYPE_WORK_PERFORMED_BY = 'performed_by';
export const SQL_DATE_FORMAT = 'YYYY-MM-DD';

export const WORK_ORDER_TYPE_AIRCRAFT = 'aircraft';

export const SIGNATURE_TYPE_TASK = 'task';

export const DATA_FIELD_TYPE_TEXT = 'text';
export const DATA_FIELD_TYPE_TEXTAREA = 'textarea';
export const DATA_FIELD_TYPE_NUMBER = 'number';
export const DATA_FIELD_TYPE_DATE = 'date';
export const DATA_FIELD_TYPE_DATETIME = 'datetime';
export const DATA_FIELD_TYPE_SINGLE_SELECT = 'single_select';
export const DATA_FIELD_TYPE_MULTIPLE_SELECT = 'multiple_select';
export const DATA_FIELD_TYPE_SWITCH = 'switch';


export const OBJECT_TYPE_TASK = 'task';
export const OBJECT_TYPE_SUBTASK = 'subtask';
export const OBJECT_TYPE_ADDITIONAL_WORK = 'additional_work';
